"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthFailedError = exports.AuthResponseErrorCode = void 0;
const client_error_1 = require("./client.error");
var AuthResponseErrorCode;
(function (AuthResponseErrorCode) {
    AuthResponseErrorCode["AUTH_FAILED"] = "AUTH_FAILED";
    AuthResponseErrorCode["AUTH_MAX_ERROR_TRIES"] = "AUTH_MAX_ERROR_TRIES";
    AuthResponseErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    AuthResponseErrorCode["PENDING_USER"] = "PENDING_USER";
    AuthResponseErrorCode["TOTP_FAILURE"] = "TOTP_FAILURE";
})(AuthResponseErrorCode = exports.AuthResponseErrorCode || (exports.AuthResponseErrorCode = {}));
class AuthFailedError extends client_error_1.ClientError {
    constructor(response) {
        super(response);
    }
}
exports.AuthFailedError = AuthFailedError;
//# sourceMappingURL=auth.failed.error.js.map